import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { EmailBrandingResource } from "api/resource/email-branding";
import { loginReset } from "redux/slice/authentication";

/** Email Branding (emailDefaults.cfm) — MAX-3889. Copied from the search-cities settings slice. */
export interface EmailBrandingState {
	loading?: boolean;
	error?: string | null;
	emailBranding?: EmailBrandingResource;
}

const initialState: EmailBrandingState = {
	loading: false,
};

export const fetchEmailBranding = createAsyncThunk("emailBranding/fetch", async (_, thunkAPI) => {
	thunkAPI.dispatch(emailBrandingLoading());
	const result = api.getEmailBranding();
	result
		.then((b) => thunkAPI.dispatch(emailBrandingLoaded(b)))
		.catch((e) => thunkAPI.dispatch(emailBrandingFailed(e)));
	return result;
});

export const saveEmailBranding = createAsyncThunk(
	"emailBranding/save",
	async (payload: EmailBrandingResource, thunkAPI) => {
		thunkAPI.dispatch(emailBrandingLoading());
		const result = api.updateEmailBranding(payload);
		result
			.then((b) => thunkAPI.dispatch(emailBrandingLoaded(b)))
			.catch((e) => thunkAPI.dispatch(emailBrandingFailed(e)));
		return result;
	}
);

export const emailBrandingSlice = createSlice({
	name: "emailBranding",
	initialState,
	reducers: {
		emailBrandingLoading: (state) => {
			state.loading = true;
		},
		emailBrandingLoaded: (state, action: PayloadAction<EmailBrandingResource>) => {
			state.loading = false;
			state.error = null;
			state.emailBranding = action.payload;
		},
		emailBrandingFailed: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload && action.payload.message;
		},
	},
	extraReducers(builder) {
		builder.addCase(loginReset, () => {
			return initialState;
		});
	},
});

export const { emailBrandingLoading, emailBrandingLoaded, emailBrandingFailed } = emailBrandingSlice.actions;
